export const IS_DEV = import.meta.env.DEV && import.meta.env.VITE_IS_DEV !== 'false';

/** Build mode shown in Account Settings; the web build has no native version. */
export const APP_ENVIRONMENT = import.meta.env.MODE;
